// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { HttpFile } from '../http/http';

export class ApiWaveVoter {
    'voter': ApiProfileMin;
    'votes_summed': number;
    'positive_votes_summed': number;
    'negative_votes_summed': number;
    'absolute_votes_summed': number;
    'min_vote': number;
    'max_vote': number;
    'different_drops_voted': number;
    'average_vote': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "voter",
            "baseName": "voter",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "votes_summed",
            "baseName": "votes_summed",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "positive_votes_summed",
            "baseName": "positive_votes_summed",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "negative_votes_summed",
            "baseName": "negative_votes_summed",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "absolute_votes_summed",
            "baseName": "absolute_votes_summed",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "min_vote",
            "baseName": "min_vote",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "max_vote",
            "baseName": "max_vote",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "different_drops_voted",
            "baseName": "different_drops_voted",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "average_vote",
            "baseName": "average_vote",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveVoter.attributeTypeMap;
    }

    public constructor() {
    }
}
